import Api from "../apiService";

class FleetParksApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/fleet/parks`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/fleet/parks`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/parks/${id}`,
      data,
      Api.authHeaders()
    );
  }

  archive(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/parks/${id}/archive`,
      {},
      Api.authHeaders()
    );
  }

  restore(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/parks/${id}/restore`,
      {},
      Api.authHeaders()
    );
  }

  reorder(companyId, data) {
    return Api.patchRequest(
      `companies/${companyId}/fleet/parks/reorder`,
      data,
      Api.authHeaders()
    );
  }

  assignVehicles(companyId, id, data) {
    return Api.postRequest(
      `companies/${companyId}/fleet/parks/${id}/assign_vehicles`,
      data,
      Api.authHeaders()
    );
  }
}

export default new FleetParksApi();
